export default __webpack_public_path__ + "static/media/support_white.b9906d42.svg";